import ChatbotInput from './ChatbotInput.jsx';

export default ChatbotInput;